"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotlightTrendingConfigDto = exports.SpotlightTrendingRulesDto = exports.SpotlightTrendingCountRuleDto = exports.SpotlightTrendingFlagRuleDto = void 0;
const swagger_1 = require("@nestjs/swagger");
class SpotlightTrendingFlagRuleDto {}
exports.SpotlightTrendingFlagRuleDto = SpotlightTrendingFlagRuleDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], SpotlightTrendingFlagRuleDto.prototype, "enabled", void 0);
class SpotlightTrendingCountRuleDto {}
exports.SpotlightTrendingCountRuleDto = SpotlightTrendingCountRuleDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], SpotlightTrendingCountRuleDto.prototype, "enabled", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  minimum: 0
}), __metadata("design:type", Number)], SpotlightTrendingCountRuleDto.prototype, "minCount", void 0);
class SpotlightTrendingRulesDto {}
exports.SpotlightTrendingRulesDto = SpotlightTrendingRulesDto;
__decorate([(0, swagger_1.ApiProperty)({
  type: SpotlightTrendingFlagRuleDto
}), __metadata("design:type", SpotlightTrendingFlagRuleDto)], SpotlightTrendingRulesDto.prototype, "hotPlaces", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: SpotlightTrendingCountRuleDto
}), __metadata("design:type", SpotlightTrendingCountRuleDto)], SpotlightTrendingRulesDto.prototype, "checkinsPerDay", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: SpotlightTrendingFlagRuleDto
}), __metadata("design:type", SpotlightTrendingFlagRuleDto)], SpotlightTrendingRulesDto.prototype, "nearHotspot", void 0);
class SpotlightTrendingConfigDto {}
exports.SpotlightTrendingConfigDto = SpotlightTrendingConfigDto;
__decorate([(0, swagger_1.ApiProperty)({
  type: SpotlightTrendingRulesDto
}), __metadata("design:type", SpotlightTrendingRulesDto)], SpotlightTrendingConfigDto.prototype, "rules", void 0);
//# sourceMappingURL=SpotlightTrendingConfig.dto.js.map